var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAircraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: "M52,72 L15,80 L15,70 L52,48 L52,23 C52,18.5872351 55.5907123,15 60,15 C64.418278,15 68,18.5826812 68,23 L68,48 L105,70 L105,80 L68,72 L68,90 L75,104.969 L60,102 L45,104.969 L52,90 L52,72 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAircraft);
export default __webpack_public_path__ + "static/media/aircraft.993e437c2cd054d799a66d9caeb498c0.svg";
export { ForwardRef as ReactComponent };